// key_helper.js
// DEFAULT SETTINGS FOR FORMAT
export const DEFAULT_SETTINGS = {
    DATE_FORMAT: 'dd-MM-yyyy',
    PAYLOAD_DATE_FORMAT: 'yyyy-MM-dd',
    DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm:ss',

};
export const STORAGE_KEYS = {
    PRIMARY_COLOR: 'AFX_BP_USER_PRIMARY_COLOR',
    ACCESS_TOKEN: 'AFX_BP_USER_ACCESS_TOKEN',
    REMEMBER_ME: 'AFX_BP_USER_REMEMBER_ME',
    BRIDGE_VIEW: 'BRIDGE_VIEW',
    BRIDGE_POSITION_TABLE_KEY: 'BRIDGE_POSITION',
    BRIDGE_SIGNAL_TABLE_KEY: 'BRIDGE_SIGNALS',
    STRATGEY_ORDERS_TABLE_KEY: 'STRATEGY_ORDERS',
    STRATEGY_RECORDS_TABLE_KEY: 'STRATGEY_RECORDS',
    ACCOUNT_POSITIONS_TABLE_KEY: 'ACCOUNT_POSITIONS',
    ACCOUNT_PENDING_ORDERS_TABLE_KEY: 'ACCOUNT_PENDING_ORDERS',
    ACCOUNT_HISTORICAL_DEALS_TABLE_KEY: 'ACCOUNT_HISTORICAL_DEALS',
    WALLET_TABLE_KEY: 'WALLET',
    ACTIVITY_LOGS_TABLE_KEY: 'ACTIVITY_LOGS',
    ORDER_HISTORY_TABLE_KEY: "ORDER_HISTORY",
    REFERRAL_USERS_TABLE_KEY: "REFERRAL_USERS",
    REFERRAL_EARNING_TABLE_KEY: 'REFERRAL_EARNING',
    CONFIGS: 'AFX_BP_USER_CONFIGS',
    PROFILE: 'AFX_BP_USER_PROFILE',
    THEME_COLORS: 'AFX_THEME_COLORS',
    MY_STRATEGY_TABLE_KEY: "MY_STARTEGY_TABLE",
    ACCOUNT_VIEW_KEY: 'ACCOUNT_VIEW_KEY',
    ACCOUNT_TABLE_KEY: 'ACCOUNT_TABLE_KEY'
}
export const TAB_UI_TYPE = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    TIME: 'TIME'
}
export const SORT_ORDER = {
    ASCENDING: "ASC",
    DESCENDING: "DESC"
}

export const ROUTES = {
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    REGISTRATION: '/registration',
    PROFILE: '/profile',
    DASHBOARD: '/dashboard',
    ACCOUNT: '/account',
    ACCOUNT_DETAILS: (brokerId = ':broker_id') => `/account/${brokerId}`,
    STRATEGY: '/strategy',
    STRATEGY_DETAILS: (strategyId = ':strategy_id') => `/strategy/${strategyId}`,
    MY_STRATEGY: '/my-strategy',
    MY_STRATEGY_DETAILS: (strategyId = ':strategy_id') => `/my-strategy/${strategyId}`,
    BRIDGE: '/bridge',
    TRADING_VIEW_SYNTAX_GENERATOR: (bridgeId = ':bridge_id') => `/bridge/tradingviewbridge/${bridgeId}`,
    CUSTOM_BRIDGE_DETAILS: (bridgeId = ':bridge_id') => `/bridge/${bridgeId}`,
    WALLET: '/wallet',
    ACTIVITY_LOGS: '/activitylogs',
    ORDER_HISTORY: '/orderhistory',
    REFERRAL: '/referral',
    NOT_FOUND: '/404',

};
export const BRIDGE_TAB_TYPE = {
    TRADINGVIEW_BRIDGE: 'Trading View Connection',
    CUSTOM_BRIDGE: 'Custom Bridge',
}
export const BRIDGE_DETAILS_TAB = {
    SIGNALS: 'Signals',
    POSITIONS: 'Positions'
}
export const STRATEGY_DETAILS_TAB = {
    RECORDS: 'Records',
    ORDERS: 'Orders',
}
export const ACCOUNT_DETAILS_TAB = {
    POSITIONS: 'Positions',
    PENDING_ORDERS: 'Pending Orders',
    HISTORY: 'History'
}
export const DROPDOWN_OPTIONS = {
    BRIDGE_SORT_OPTION: [
        { value: 'bridge_name', label: 'Name' },
        { value: 'bridge_trading_flag', label: 'Trading Status' },
        { value: 'is_bridge_connected', label: 'Connection' },
        { value: 'connection_name', label: 'Connected Name' },
    ],
    ACCOUNT_SORT_OPTION: [
        { value: 'broker_combine_name', label: 'Name' },
        { value: 'main_trading_flag', label: 'Trading Status' },
        { value: 'broker_flag', label: 'Connection' },
        { value: 'balance', label: 'Balance($)' },
        { value: 'equity', label: 'Equity($)' },
        { value: 'margin_free', label: 'Free Margin ($)' },
        { value: 'margin', label: 'Margin ($)' },
        { value: 'floating_profit', label: 'P&L' },
        { value: 'positions_count', label: 'POS' },
        { value: 'orders_count', label: 'Pending Orders' },
        { value: 'end_date', label: 'Expired Date' },
        { value: 'group_involve_count', label: 'Group Count' }
    ],
    SL_TP_TYPE_OPTION: [
        { value: undefined, label: 'Value' },
        { value: 'PIP', label: 'Pip' },
        { value: 'PERCENTAGE', label: 'Percentage' },

    ],
    EXIT_ON_OPPOSITE_OPTION: [
        { value: true, label: 'Yes' },
        { value: false, label: 'No' }
    ],
    BRIDGE_POSITION_STATUS_OPTION: [
        { value: true, label: 'Open' },
        { value: false, label: 'Closed' }
    ],
    BRIDGE_SIGNAL_OPTION: [
        { value: 'BUY', label: 'BUY' },
        { value: 'SELL', label: 'SELL' },
        { value: 'NONE', label: 'NONE' }

    ],
    STRATEGY_SORT_OPTIONS: [
        { value: 'grp_name', label: 'Name' },
        { value: 'capital_required', label: 'Capital Required' },
        { value: 'is_subscribed', label: 'Subscription Status' }
    ],
    ORDER_TYPE_OPTION: [
        { value: 0, label: 'BUY' },
        { value: 1, label: 'SELL' },
        { value: 2, label: 'BUY LIMIT' },
        { value: 3, label: 'SELL LIMIT' },
        { value: 4, label: 'BUY STOP' },
        { value: 5, label: 'SELL STOP' },
        { value: 6, label: 'BUY STOP LIMIT' },
        { value: 7, label: 'SELL STOP LIMIT' },

    ],
    ORDER_STATE_TYPE_OPTION: [
        { value: 0, label: 'STARTED' },
        { value: 1, label: 'PLACED' },
        { value: 2, label: 'CANCELED' },
        { value: 3, label: 'PARTIAL' },
        { value: 4, label: 'FILLED' },
        { value: 5, label: 'REJECTED' },
        { value: 6, label: 'EXPIRED' },
        { value: 7, label: 'REQUEST ADD' },
        { value: -1, label: 'FAILED' },

    ],
    AGE_RANGE_OPTION: [
        { value: "Below 18", label: "Below 18 years" },
        { value: "18-30", label: "18 - 30 years" },
        { value: "30-50", label: "30 - 50 years" },
        { value: "Above 50", label: "Above 50 years" }
    ],
    WALLET_TRANSACTION_OPTION: [
        { value: 'credit', label: 'Credit' },
        { value: 'debit', label: 'Debit' }
    ],
    ORDER_HISTORY_FROM_OPTION: [
        { value: 'manual', label: 'Manual' },
        { value: 'copytrading', label: 'Copy Trading' },
        { value: 'bridge', label: 'Bridge' },
        { value: 'api', label: 'API' }

    ],
}

export const ACCOUNT_SEARCH_KEYWORDS = ["broker_combine_name"];

export const BRIDGE_SEARCH_KEYWORDS = ["bridge_name", "connection_name"];
export const STRATEGY_SEARCH_KEYWORD = ["group_name", "strategy_description", "capital_required"];
export const CONFIRMATION_ACTION_TYPE = {
    DELETE: 'delete',
    STATUS_UPDATE: 'status',
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    CASHOUT_CREDIT: 'cashout_credit',
    SQUARE_OFF: 'square_off',
    CANCEL: 'cancel',
    REGENERATE_KEY: 'regenerate_key',
    REFRESH: 'refresh',
    SYNC_BALANCE: 'sync_balance',
    RENEW: 'renew',
    EXTEND: 'extend'
}
export const BRIDGE_SIGNAL_PLACE_OERDRE_TYPE = {
    BUY: "BUY",
    SELL: "SELL",
    EXIT: "EXIT"
}
export const BRIDGE_TYPE = {
    CUSTOM: 'custom',
    TRADING_VIEW: 'trading-view'
}

export const BRIDGE_TRADING_VIEW_TYPE = {
    MARKET: 'market_order',
    STRATEGY: 'strategy_order',
    LIMIT: 'limit_order',
    CANCEL: 'cancel_order',
    CLOSE: 'close_position',
    SIMULATION: 'simulation_mode'
}
export const REVERSE_BRIDGE_TRADING_VIEW_TYPE = Object.entries(BRIDGE_TRADING_VIEW_TYPE)
    .reduce((acc, [key, value]) => {
        acc[value] = key;
        return acc;
    }, {});
export const DEFAULT_STRATEGY_SYNTAX = {
    type: "strategy_order",
    symbol: "{{ticker}}",
    volume: "{{strategy.position_size}}",
    position_size: "{{strategy.position_size}}",
    side: "{{strategy.order.action}}",
    current_price: "{{close}}",
    exit_on_opposite: 0

}
export const ORDER_EXECUTION_TYPE = {
    [-1]: "DEPOSIT",
    [-2]: "WITHDRAW",
    0: 'BUY',
    1: 'SELL',
    2: 'BUY LIMIT',
    3: 'SELL LIMIT',
    4: 'BUY STOP',
    5: 'SELL STOP',
    6: 'BUY STOP LIMIT',
    7: 'SELL STOP LIMIT',
}

export const ORDER_STATE_TYPE = {
    [-1]: 'FAILED',
    [0]: 'STARTED',
    [1]: 'PLACED',
    [2]: 'CANCELED',
    [3]: 'PARTIAL',
    [4]: 'FILLED',
    [5]: 'REJECTED',
    [6]: 'EXPIRED',
    [7]: 'REQUEST ADD',
}
export const ACCOUNT_CONNECTION_TYPE = {
    CONNECT_WITH_SERVER: 'Connect With Server',
    CONNECT_WITH_HOST: 'Connect With Host'
}
export const ORDER_TYPE = {
    BUY: 0,
    SELL: 1,
    BUY_LIMIT: 2,
    SELL_LIMIT: 3,
    BUY_STOP: 4,
    SELL_STOP: 5,
    BUY_STOP_LIMIT: 6,
    SELL_STOP_LIMIT: 7,
};

export const API_RESPONSE_TYPE = {
    OTP: 'otp',
    OTP_EXPIRED: 'otp-expired',
    OTP_INVALID: 'otp-invalid',
    EMAIL_USED: 'email-used',
}
export const RECAPTCHA_ACTIONS = {
    REGISTER: "REGISTER",
    FORGOT_PASSWORD: "FORGOT_PASSWORD",
};

export const TRANSACTION_TYPE = {
    CREDIT: 'credit',
    DEBIT: 'debit'
}

export const REFEERAL_CODE = 'referral';

export const REFERRAL_TAB = {
    REFERRAL_USERS: 'Referral Users',
    REFERRAL_EARNING: 'Referral Earning'
}
export const ACCOUNT_QUEUE_STATUS = {
    CONNECTING: 'connecting',
    RENEWING: 'renewing',
    FAILED: 'failed',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled'
}
export const LOGO_TYPE = {
    HORIZONTAL_LOGO: 'horizontal_logo',
    VERTICAL_LOGO: 'vertical_logo',
}
export const THEME_VARAIBLE_MAP = {
    primary_color: "--color-primary",
    background_color: "--color-background",
    hover_color: "--color-hover",
    card_color: "--color-surface-card",
    input_color: "--color-surface-input",
    subcard_color: "--color-surface-subcard",
    expiry_card_color: "--surface-expired",
    loading_overlay: "--loading-overlay",
    primary_text_color: "--color-text-primary",
    secondary_text_color: "--text-secondary",
    placeholder_text_color: "--text-placeholder",
    button_text_color: "--btn-text",
    text_color_on_primary: "--text-on-primary",
    border_color: "--color-border",
    scrollbar_color: "--color-scrollbar",
    shadow_card_color: "--shadow-card",
    error_color: "--error",
    error_bg_color: "--error-bg",
    warning_color: "--warning",
    warning_bg_color: "--warning-bg",
    info_color: "--info",
    info_bg_color: "--info-bg",
    success_color: "--success",
    success_bg_color: "--success-bg",
    pnl_profit_chart_top: "--pnl-profit-chart-top",
    pnl_profit_chart_bottom: "--pnl-profit-chart-bottom",
    pnl_loss_chart_top: "--pnl-loss-chart-top",
    pnl_loss_chart_bottom: "--pnl-loss-chart-bottom"
};
export const UI_TYPE = {
    CARD: 'card',
    TABLE: 'table',
    CHART: 'chart'
}

export const UPDATE_STARTEGY_ACCOUNT_ACTION_TYPE = {
    ADD: 'add',
    REMOVE: 'remove',
    CHANGE: 'change'
}
export const DEVICE_TYPE = {
    WINDOWS: 'Android/Windows',
    MACOS: 'iOS/macOS'
}